//ng build --configuration=preprod
export const environment = {
  production: false,
  displayProPlus: true,
  displaySelflearnRecommendedVideos:true,
  doBajajEncryption: true,
  sendTrackAPIOnSignInOrSignUp:true,
  displayNewPayInParts:false,
  useV1API: true,
  enableJodoEMIResume: true,
  enableResumeJodoFlex: true,
  displayShopSe: true,
  websitedisplayShopSe: true,
  displayEarlySalary: true,
  websitedisplayEarlySalary: true,
  packageExpiredCheck: false,
  partPyamentBatchFix: true,
  convertTOEMI: true,
  pypPdf:true,
  myActivity : true,
  displayShippingCity:true,
  expiryWithDateTime:false,
  reportRevamp:false,
  earlySalaryWebsireRedirectionUrl: 'https://portal-uat.earlysalary.com/SignUp',
  api: 'https://api.devinfinitylearn.in',
  api1: 'https://newasmapi.devinfinitylearn.in/',
  apiNew: 'https://newasmapi.devinfinitylearn.in/',
  cyotdevApi: 'https://newqbapi.devinfinitylearn.in/',
  tenant: 'infinitylearn',
  //tenant:'srichaitanya',
  portal: 'assessment', //'teacher'
  branch: 'preprod',
  ePragnaUrl: 'https://auth.epraghna.com',
  FRONT_END_URL: 'https://student.devinfinitylearn.in',
  ZOOM_LEAVE_URL: 'https://student.devinfinitylearn.in/dashboard/liveclass',
  WEB_SOCKET_URI: 'https://lcwebsocketpreprod.devinfinitylearn.in',
  LIVE_CLASS_API: 'https://livepreprodapi.devinfinitylearn.in/api/v1/',
  SELF_LEARN_API: 'https://selflearnapi.devinfinitylearn.in',
  SELF_LEARN_API_V2: 'https://selflearnv2api.devinfinitylearn.in/',
  omsdevapi: 'https://omsapi.devinfinitylearn.in/api/',//preprod
  // omsdevapi: 'https://omsstagingapi.devinfinitylearn.in/api/',
  uafapi: 'https://myactivity.devinfinitylearn.in/api/',
  usersapi: 'https://api.devinfinitylearn.in/api/',
  CMS_API: 'https://cmspreprodapi.devinfinitylearn.in/',
  razorkey: 'rzp_test_cbwfDx2vukD9jT',
  homeRoute: 'https://devinfinitylearn.in/',
  studentDashboard: 'https://devinfinitylearn.in/',
  Domain: '.devinfinitylearn.in',
  AGORA_APP_ID: 'ba17e305035c48a39811bd55400ec84b',
  TRACKJS_KEY: '75794dfef37745f3953a791f0e464344',
  myActivity_url: 'https://myactivity.devinfinitylearn.in/', //preprod
  EXAM_ID_CONVERSION_FROM_UAM_TO_CMS: [
    { CMS_ID: 1, UAM_ID: 2 },
    { CMS_ID: 2, UAM_ID: 1 },
    { CMS_ID: 3, UAM_ID: 5 },
    { CMS_ID: 4, UAM_ID: 7 },
    { CMS_ID: 5, UAM_ID: 6 },
    { CMS_ID: 8, UAM_ID: 8 },
  ],
  firebase:{
    apiKey: "AIzaSyBOvjfYqrlsYHALU936NXq7MZjXDDudl2c",
    authDomain: "doubts-aa0c1.firebaseapp.com",
    databaseURL: "https://doubts-aa0c1-default-rtdb.firebaseio.com",
    projectId: "doubts-aa0c1",
    storageBucket: "doubts-aa0c1.appspot.com",
    messagingSenderId: "339511367616",
    appId: "1:339511367616:web:6f17eae5ca85b21026da25",
    measurementId: "G-TYE54HH585"
  },
  messages:'stag_chats',
  status:'status_stag',
  gtm:'GTM-TCS6GVV',
  displayDoubtsWeb: true,
  dcapi: 'https://dcapi.devinfinitylearn.in',
  dsrapi: 'https://drs.devinfinitylearn.in/',
  unifiedweb: 'https://devinfinitylearn.in/',
  Bajaj: {
    showBajaj: true,
    min_amount: 1,
    max_amount: 2,
    Durations: [
      { tenor: 3, schemeId: "81526" },
      { tenor: 6, schemeId: "81527" },
    ],
  },
  showEarlySalary: true,
  Jodo: {
    jodo_auth_host: "https://api.devtest1.jodopay.com",
    displayCred: true,
    displayFlex: true,
    websitedisplayCred: true,
    websitedisplayFlex: true,
  },
  successHome: 'https://success-centersdev.devinfinitylearn.in/',
  scoreToiURL: 'https://us-central1-times-stem.cloudfunctions.net/timesApi/addUserTest',
  scoreToiStatusURL: 'https://us-central1-times-stem.cloudfunctions.net/timesApi/updateScoreStatusTest',
  scoreToiKey: 123,
  scatHome: 'https://srichaitanyascore.devinfinitylearn.in/',
  UAM_TO_CMS_CONVERSION :[
    {
      "UAM_Exam_Name": "NEET",
      "UAM_Grade_Name": "13th",
      "CMS_Exam_Name": "NEET",
      "CMS_Grade_Name": 13,
      "UAM_exam_id": 2,
      "UAM_grade_id": 7,
      "CMS_Exam_id": 1,
      "CMS_grade_id": 13
    },
    {
      "UAM_Exam_Name": "NEET",
      "UAM_Grade_Name": "12th",
      "CMS_Exam_Name": "NEET",
      "CMS_Grade_Name": 12,
      "UAM_exam_id": 2,
      "UAM_grade_id": 3,
      "CMS_Exam_id": 1,
      "CMS_grade_id": 12
    },
    {
      "UAM_Exam_Name": "NEET",
      "UAM_Grade_Name": "11th",
      "CMS_Exam_Name": "NEET",
      "CMS_Grade_Name": 11,
      "UAM_exam_id": 2,
      "UAM_grade_id": 2,
      "CMS_Exam_id": 1,
      "CMS_grade_id": 11
    },
    {
      "UAM_Exam_Name": "NEET",
      "UAM_Grade_Name": "10th",
      "CMS_Exam_Name": "NEET",
      "CMS_Grade_Name": 10,
      "UAM_exam_id": 2,
      "UAM_grade_id": 1,
      "CMS_Exam_id": 1,
      "CMS_grade_id": 10
    },
    {
      "UAM_Exam_Name": "NEET",
      "UAM_Grade_Name": "9th",
      "CMS_Exam_Name": "NEET",
      "CMS_Grade_Name": 9,
      "UAM_exam_id": 2,
      "UAM_grade_id": 9,
      "CMS_Exam_id": 1,
      "CMS_grade_id": 9
    },
    {
      "UAM_Exam_Name": "JEE Main",
      "UAM_Grade_Name": "13th",
      "CMS_Exam_Name": "JEE Main",
      "CMS_Grade_Name": 13,
      "UAM_exam_id": 1,
      "UAM_grade_id": 7,
      "CMS_Exam_id": 2,
      "CMS_grade_id": 13
    },
    {
      "UAM_Exam_Name": "JEE Main",
      "UAM_Grade_Name": "12th",
      "CMS_Exam_Name": "JEE Main",
      "CMS_Grade_Name": 12,
      "UAM_exam_id": 1,
      "UAM_grade_id": 3,
      "CMS_Exam_id": 2,
      "CMS_grade_id": 12
    },
    {
      "UAM_Exam_Name": "JEE Main",
      "UAM_Grade_Name": "11th",
      "CMS_Exam_Name": "JEE Main",
      "CMS_Grade_Name": 11,
      "UAM_exam_id": 1,
      "UAM_grade_id": 2,
      "CMS_Exam_id": 2,
      "CMS_grade_id": 11
    },
    {
      "UAM_Exam_Name": "JEE Main",
      "UAM_Grade_Name": "10th",
      "CMS_Exam_Name": "JEE Main",
      "CMS_Grade_Name": 10,
      "UAM_exam_id": 1,
      "UAM_grade_id": 1,
      "CMS_Exam_id": 2,
      "CMS_grade_id": 10
    },
    {
      "UAM_Exam_Name": "JEE Main",
      "UAM_Grade_Name": "9th",
      "CMS_Exam_Name": "JEE Main",
      "CMS_Grade_Name": 9,
      "UAM_exam_id": 1,
      "UAM_grade_id": 9,
      "CMS_Exam_id": 2,
      "CMS_grade_id": 9
    },
    {
      "UAM_Exam_Name": "JEE Advanced",
      "UAM_Grade_Name": "13th",
      "CMS_Exam_Name": "JEE Advanced",
      "CMS_Grade_Name": 13,
      "UAM_exam_id": 3,
      "UAM_grade_id": 7,
      "CMS_Exam_id": 3,
      "CMS_grade_id": 13
    },
    {
      "UAM_Exam_Name": "JEE Advanced",
      "UAM_Grade_Name": "12th",
      "CMS_Exam_Name": "JEE Advanced",
      "CMS_Grade_Name": 12,
      "UAM_exam_id": 3,
      "UAM_grade_id": 3,
      "CMS_Exam_id": 3,
      "CMS_grade_id": 12
    },
    {
      "UAM_Exam_Name": "JEE Advanced",
      "UAM_Grade_Name": "11th",
      "CMS_Exam_Name": "JEE Advanced",
      "CMS_Grade_Name": 11,
      "UAM_exam_id": 3,
      "UAM_grade_id": 2,
      "CMS_Exam_id": 3,
      "CMS_grade_id": 11
    },
    {
      "UAM_Exam_Name": "CBSE",
      "UAM_Grade_Name": "12th",
      "CMS_Exam_Name": "CBSE Grade 12",
      "CMS_Grade_Name": 12,
      "UAM_exam_id": 6,
      "UAM_grade_id": 3,
      "CMS_Exam_id": 12,
      "CMS_grade_id": 12
    },
    {
      "UAM_Exam_Name": "CBSE",
      "UAM_Grade_Name": "11th",
      "CMS_Exam_Name": "CBSE Grade 11",
      "CMS_Grade_Name": 11,
      "UAM_exam_id": 6,
      "UAM_grade_id": 2,
      "CMS_Exam_id": 11,
      "CMS_grade_id": 11
    },
    {
      "UAM_Exam_Name": "CBSE",
      "UAM_Grade_Name": "10th",
      "CMS_Exam_Name": "CBSE Grade 10",
      "CMS_Grade_Name": 10,
      "UAM_exam_id": 6,
      "UAM_grade_id": 1,
      "CMS_Exam_id": 10,
      "CMS_grade_id": 10
    },
    {
      "UAM_Exam_Name": "CBSE",
      "UAM_Grade_Name": "9th",
      "CMS_Exam_Name": "CBSE Grade 9",
      "CMS_Grade_Name": 9,
      "UAM_exam_id": 6,
      "UAM_grade_id": 9,
      "CMS_Exam_id": 9,
      "CMS_grade_id": 9
    },
    {
      "UAM_Exam_Name": "CBSE",
      "UAM_Grade_Name": "8th",
      "CMS_Exam_Name": "CBSE Grade 8",
      "CMS_Grade_Name": 8,
      "UAM_exam_id": 6,
      "UAM_grade_id": 15,
      "CMS_Exam_id": 8,
      "CMS_grade_id": 8
    },
    {
      "UAM_Exam_Name": "CBSE",
      "UAM_Grade_Name": "7th",
      "CMS_Exam_Name": "CBSE Grade 7",
      "CMS_Grade_Name": 7,
      "UAM_exam_id": 6,
      "UAM_grade_id": 14,
      "CMS_Exam_id": 7,
      "CMS_grade_id": 7
    },
    {
      "UAM_Exam_Name": "CBSE",
      "UAM_Grade_Name": "6th",
      "CMS_Exam_Name": "CBSE Grade 6",
      "CMS_Grade_Name": 6,
      "UAM_exam_id": 6,
      "UAM_grade_id": 13,
      "CMS_Exam_id": 6,
      "CMS_grade_id": 6
    },
    {
      "UAM_Exam_Name": "Aptitude Test",
      "UAM_Grade_Name": "5th",
      "CMS_Exam_Name": "Aptitude Test",
      "CMS_Grade_Name": 5,
      "UAM_exam_id": 4,
      "UAM_grade_id": 12,
      "CMS_Exam_id": 5,
      "CMS_grade_id": 5
    },
    {
      "UAM_Exam_Name": "Aptitude Test",
      "UAM_Grade_Name": "4th",
      "CMS_Exam_Name": "Aptitude Test",
      "CMS_Grade_Name": 4,
      "UAM_exam_id": 4,
      "UAM_grade_id": 11,
      "CMS_Exam_id": 5,
      "CMS_grade_id": 4
    },
    {
      "UAM_Exam_Name": "Aptitude Test",
      "UAM_Grade_Name": "3rd",
      "CMS_Exam_Name": "Aptitude Test",
      "CMS_Grade_Name": 3,
      "UAM_exam_id": 4,
      "UAM_grade_id": 10,
      "CMS_Exam_id": 5,
      "CMS_grade_id": 3
    },
    {
      "UAM_Exam_Name": "Foundation Test",
      "UAM_Grade_Name": "8th",
      "CMS_Exam_Name": "Foundation Test",
      "CMS_Grade_Name": 8,
      "UAM_exam_id": 5,
      "UAM_grade_id": 15,
      "CMS_Exam_id": 4,
      "CMS_grade_id": 8
    },
    {
      "UAM_Exam_Name": "Foundation Test",
      "UAM_Grade_Name": "7th",
      "CMS_Exam_Name": "Foundation Test",
      "CMS_Grade_Name": 7,
      "UAM_exam_id": 5,
      "UAM_grade_id": 14,
      "CMS_Exam_id": 4,
      "CMS_grade_id": 7
    },
    {
      "UAM_Exam_Name": "Foundation Test",
      "UAM_Grade_Name": "6th",
      "CMS_Exam_Name": "Foundation Test",
      "CMS_Grade_Name": 6,
      "UAM_exam_id": 5,
      "UAM_grade_id": 13,
      "CMS_Exam_id": 4,
      "CMS_grade_id": 6
    },
    {
      "UAM_Exam_Name": "Aptitude Test",
      "UAM_Grade_Name": "1st",
      "CMS_Exam_Name": "Aptitude Test",
      "CMS_Grade_Name": 1,
      "UAM_exam_id": 4,
      "UAM_grade_id": 16,
      "CMS_Exam_id": 5,
      "CMS_grade_id": 1
    },
    {
      "UAM_Exam_Name": "Aptitude Test",
      "UAM_Grade_Name": "2nd",
      "CMS_Exam_Name": "Aptitude Test",
      "CMS_Grade_Name": 2,
      "UAM_exam_id": 4,
      "UAM_grade_id": 17,
      "CMS_Exam_id": 5,
      "CMS_grade_id": 2
    },
    {
      "UAM_Exam_Name": "CUET",
      "UAM_Grade_Name": "12th",
      "CMS_Exam_Name": "CUET",
      "CMS_Grade_Name": 12,
      "UAM_exam_id": 9,
      "UAM_grade_id": 3,
      "CMS_Exam_id": 40,
      "CMS_grade_id": 12
    }
  ],
  // cyotNewflow:true

};
